import { Modal, Typography, Box, Slide } from "@mui/material"
import { useState, useEffect } from "react"
import { Close as CloseIcon } from "@mui/icons-material";
import { NoDataFound } from "../../../../empty/Index";

export const History = ({historyModal, order, setHistoryModal})=>{
    const total = order?.orderList?.reduce((sum, item) => sum + item.value * item.price, 0) ;
    return(
        <Modal open={historyModal}>
            <Slide in={historyModal} direction="up">
                <Box sx={{bgcolor: "#fff", height: "100%", p: 2, display: "flex", flexDirection: "column", justifyContent: "space-between"}}>
                    <Box>
                        <Box>
                            <Box sx={{display: "flex", justifyContent: "space-between"}}>
                                <Typography sx={{fontWeight: 600}}>Previous Transaction History:</Typography>
                                <Box onClick={()=>{setHistoryModal(false)}}>
                                    <CloseIcon/>
                                </Box>
                            </Box>
                        </Box>
                        {order?.orderList?.length > 0 &&
                            order?.orderList?.map((v, k) => (
                                <SummaryList key={k} v={v} k={k}/>
                            ))
                        }
                    </Box>
                    {order?.orderList?.length > 0 ?
                        <>
                            <Box width="100%" bgcolor="#FFFFFF">
                                <Box minWidth="120px" display="flex" alignItems="center" mb={2}>
                                    <Box width="50%"></Box>
                                    <Box width="50%" display="flex" flexDirection="column" gap={.5}>
                                        <Box width="100%" display="flex" alignItems="center" justifyContent="space-between" gap="8px">
                                            <Box color={'#000000'} fontWeight={500} fontSize={12} lineHeight="16px" textAlign="center">Subtotal:</Box>
                                            <Box color={'#000000'} fontWeight={500} fontSize={12} lineHeight="16px" textAlign="center">₱ {parseFloat(total ? total : 0).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Box>
                                        </Box>
                                        <Box width="100%" display="flex" alignItems="center" justifyContent="space-between" gap="8px">
                                            <Box color={'#000000'} fontWeight={700} fontSize={16} lineHeight="16px" textAlign="center">Total:</Box>
                                            <Box color={'#000000'} fontWeight={700} fontSize={16} lineHeight="16px" textAlign="center">
                                                ₱ {(parseFloat(total ? total : 0)).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </>
                        :
                        <Box sx={{height: "100%", display: "flex", alignItems: "center"}}>
                            <NoDataFound/>
                        </Box>
                    }
                </Box>
            </Slide>
        </Modal>
    )
}

const SummaryList = ({v, k}) =>{
    const [imgUrl, setImgUrl] = useState(null);

    useEffect(() => {
        if (typeof v.image === "string") {
            setImgUrl(v.image);
        }
    }, [v.image]);

    return (
        <Box>
            <Box id={`walkthrough-checkout-step-${k}`} key={k} display="flex" alignItems="center" border="1px solid #EBEBEB" borderRadius="8px" sx={{ boxShadow: '0 1px 3px rgba(0,0,0,0.05)', backgroundColor: '#fff', py: 1, px: 2 }}>
                <Box width="50px" height="50px" borderRadius="4px"  overflow="hidden" flexShrink={0} bgcolor="#f5f5f5" mr={1.5} >
                <img src={imgUrl} alt={v.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }}/></Box>
                <Box flex={1}> <Typography fontSize={14} fontWeight={500} color="#283745">{v.name}</Typography></Box>
                <Box minWidth="60px" textAlign="center"> <Typography fontSize={13}color="#555">{v.value}</Typography></Box>
                <Box minWidth="100px" textAlign="right"> <Typography fontSize={14} fontWeight={600} color="#283745">₱ {parseFloat(v.value * v.price).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography></Box>
            </Box>
        </Box>
    )
}